import React from "react";
import { Alert, Chip, Tab, Tabs } from "@mui/material";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import { TERM_RECORDS_SCOPES } from "../../utils/termRecordsScope";

/**
 * Switch between active-term working data and prior terms (marks, attendance, fees, etc.).
 */
export function TermRecordsScopeTabs({ value, onChange, sx }) {
    return (
        <Tabs
            value={value}
            onChange={(_, next) => onChange(next)}
            sx={{ mb: 2, ...sx }}
        >
            <Tab value={TERM_RECORDS_SCOPES.CURRENT} label="Current term" />
            <Tab
                value={TERM_RECORDS_SCOPES.PAST}
                label="Past records"
                icon={<HistoryOutlinedIcon sx={{ fontSize: 18 }} />}
                iconPosition="start"
            />
        </Tabs>
    );
}

export function TermRecordsScopeAlert({ scope, currentTermLabel, sectionLabel = "records" }) {
    if (scope === TERM_RECORDS_SCOPES.PAST) {
        return (
            <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }} icon={<HistoryOutlinedIcon />}>
                Showing {sectionLabel} from previous terms. Switch to <strong>Current term</strong> for
                the active period.
            </Alert>
        );
    }
    if (currentTermLabel) {
        return (
            <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }} variant="outlined">
                Active period: <Chip size="small" label={currentTermLabel} sx={{ mx: 0.5 }} />
                Only this term&apos;s {sectionLabel} appear here. Older terms are under{" "}
                <strong>Past records</strong>.
            </Alert>
        );
    }
    return null;
}
